// Dashboard API — 9 метрик канала с динамикой

export interface MetricDeltas {
  day: number | null
  week: number | null
  month: number | null
}

export interface Metric {
  label: string
  value: number | null
  unit?: '₽' | '%'
  deltas: MetricDeltas
}

export interface DashboardSummary {
  channelUUID: string
  metrics: {
    subscribers: Metric
    botStarts: Metric
    publications: Metric
    viewsPerPost: Metric
    reactionsPerPost: Metric
    er: Metric
    err: Metric
    totalSpend: Metric
    avgPdpCost: Metric
  }
}

const USE_MOCKS = false // бэк готов — используем реальный API

// MVP: только 3 метрики реально доступны в MAX API.
// Остальные 6 — null (фронт показывает «—»).
const MOCK_DATA: DashboardSummary = {
  channelUUID: 'mock-channel',
  metrics: {
    subscribers: {
      label: 'Всего подписчиков',
      value: 1245,
      deltas: { day: 12, week: 87, month: 312 },
    },
    totalSpend: {
      label: 'Общий расход',
      value: 76823.38,
      unit: '₽',
      deltas: { day: 8.56, week: 56615, month: 76823 },
    },
    avgPdpCost: {
      label: 'Стоимость ПДП',
      value: 121.75,
      unit: '₽',
      deltas: { day: null, week: null, month: null },
    },
    botStarts: {
      label: 'Запусков бота',
      value: null,
      deltas: { day: null, week: null, month: null },
    },
    publications: {
      label: 'Публикаций в каналах',
      value: null,
      deltas: { day: null, week: null, month: null },
    },
    viewsPerPost: {
      label: 'Просмотров на пост',
      value: null,
      deltas: { day: null, week: null, month: null },
    },
    reactionsPerPost: {
      label: 'Реакций на пост',
      value: null,
      deltas: { day: null, week: null, month: null },
    },
    er: {
      label: 'ER',
      value: null,
      unit: '%',
      deltas: { day: null, week: null, month: null },
    },
    err: {
      label: 'ERR',
      value: null,
      unit: '%',
      deltas: { day: null, week: null, month: null },
    },
  },
}

export async function getDashboardSummary(channelUUID: string): Promise<DashboardSummary> {
  if (USE_MOCKS) {
    // имитация задержки
    await new Promise((r) => setTimeout(r, 300))
    return { ...MOCK_DATA, channelUUID }
  }

  const res = await fetch(`/api/max/dashboard/summary?channelUUID=${encodeURIComponent(channelUUID)}`, {
    credentials: 'include',
  })
  if (!res.ok) {
    const err = await res.json().catch(() => ({ error: `HTTP ${res.status}` }))
    throw Object.assign(new Error(err.error || `HTTP ${res.status}`), { status: res.status })
  }
  return res.json()
}
